import regular from '@fontsource/vazirmatn/files/vazirmatn-arabic-400-normal.woff2?url';
import bold from '@fontsource/vazirmatn/files/vazirmatn-arabic-700-normal.woff2?url';

/**
 * Arabic-script text (Arabic, Persian) is shown in Vazirmatn. Only the Arabic subset in two
 * weights ships with the extension (about 43 KB); Latin letters inside such a sentence (a German
 * name such as "Hamburg") are not in that file, so they fall through to the system font.
 */
export const ARABIC_SCRIPT_FONT_STACK =
  "'Vazirmatn', 'Geeza Pro', 'Segoe UI', Tahoma, 'Noto Naskh Arabic', sans-serif";

const STYLE_ID = 'lingoping-vazirmatn';

/** Registers the @font-face rules once per page (the files are local, so any extension CSP allows them). */
export function ensureTranslationFont(): void {
  if (typeof document === 'undefined' || document.getElementById(STYLE_ID)) return;
  const face = (weight: number, url: string) =>
    `@font-face{font-family:'Vazirmatn';font-style:normal;font-display:swap;font-weight:${weight};` +
    `src:url("${url}") format("woff2");}`;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = face(400, regular) + face(700, bold);
  document.head.appendChild(style);
}
